/**
 * This function checks if the size is more than 100mb or not
 * @param size of the file
 * @param sizeLimit of the file
 */
export function checkSize(size: string, sizeLimit: number = 100): boolean {
  return size.toLowerCase().includes('gb') || (size.toLowerCase().includes('mb') && parseFloat(size.replace(/[^0-9\.]/g, '')) > sizeLimit);
}

/**
 * @description Converts the bytes to readable file size
 *
 * @param sizeInBytes size of in bytes
 * @param decimals Number of floating point to round off
 * @return string
 */
export function getFileSize(sizeInBytes: number, decimals: number = 2): string {
  if (sizeInBytes === 0) return '0 Bytes';
  if (isNaN(sizeInBytes)) return '-';

  const kiloReference: number = 1024;
  const decimalPoints: number = decimals < 0 ? 0 : decimals;
  const sizes: string[] = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

  const formatIndex: number = Math.floor(Math.log(sizeInBytes) / Math.log(kiloReference));
  const formattedSize: number = parseFloat((sizeInBytes / Math.pow(kiloReference, formatIndex)).toFixed(decimalPoints));

  return `${formattedSize} ${sizes[formatIndex]}`;
}
